import { Injectable } from "@angular/core";
// import { Observable, Observer, Subject} from 'rxjs'
import * as Rx from "rxjs";
import { UserService } from "./user.service";
import { environment } from "@env/environment";
import { HttpUtilService } from "./http-util.service";
import moment from "moment";

@Injectable({
  providedIn: "root",
})

/**
 * @description WebsocketService is a service that connects to the K16 websocket API. This service will be phased out in favor of web-socket.service.ts
 * @category Services
 * @deprecated
 */
export class WebsocketService {
  /** Current socket message*/
  public messages: Rx.Subject<any>;
  /** Subscriptiojn for socket connection*/
  private subject: Rx.Subject<any>;
  /** socket connection*/
  public ws: any;

  public classRefresh = new Rx.Subject();
  /** Durration of socket before refresh is needed*/
  socketExpiration: moment.Moment;
  /** General purpose socket store*/
  updateSocket: any;
  /** Id of socket connection*/
  socketConnectionId;
  listener: Rx.Subject<any>;

  constructor(
    private userService: UserService,
    private httpUtils: HttpUtilService
  ) { }
  /**
   * Open a socket connection
   * @param url url to initiate the connection
   */
  public connect(): Rx.Subject<any> {
    if (!this.subject) {
      this.subject = this.create();
    }
    return this.subject;
  }

  public createSocket(): WebSocket {
    if (this.userService.isLoggedIn()) {
      let queryPath = "?user-pool-id=" + environment.cognitoUserPoolId;
      queryPath += "&client-id=" + environment.cognitoClientId;
      queryPath += "&Authorization=" + this.userService.accessToken;
      return new WebSocket(this.getSocketUrl() + queryPath);
    }
  }
  /**
   * Close the socket connection
   * @param connectionId Connection id of the socket to close
   */
  public close(connectionId = null) {
    if (this.ws) {
      if (this.ws.readyState === WebSocket.OPEN) {
        // If socket is still in open state just send disconnect message
        this.ws.send(JSON.stringify({ action: "disconnect" }));
        this.ws.close();
      } else if (connectionId) {
        // Fire and forget delete request to clear out connection from DB if it's no longer open
        this.httpUtils
          .request(
            "DELETE",
            environment.apiRoot + "/connections/" + connectionId,
            null,
            null,
            true
          )
          .subscribe();
      }

      this.subject = null;
    }
  }
  /**
   * Reate a socket connection
   * @param url URL to initate the socket
   */
  private create(): Rx.Subject<any> {
    let queryPath = "?user-pool-id=" + environment.cognitoUserPoolId;
    queryPath += "&client-id=" + environment.cognitoClientId;
    queryPath += "&Authorization=" + this.userService.accessToken;

    this.ws = new WebSocket(this.getSocketUrl() + queryPath);
    const observable = Rx.of((obs: Rx.Observer<any>) => {
      this.ws.onopen = obs.next.bind(obs);
      this.ws.onmessage = obs.next.bind(obs);
      this.ws.onerror = obs.error.bind(obs);
      this.ws.onclose = obs.complete.bind(obs);
      return this.ws.close.bind(this.ws);
    });
    const observer = {
      next: (data: Object) => {
        if (this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(JSON.stringify(data));
        }
      },
    };
    return Rx.Subject.create(observer, observable);
  }

  private connectSocket() {
    let user;
    this.userService.getRoleDetails(false).subscribe((u) => user = u);
    console.log(user);
    console.log(this.userService);
    const socket = this.createSocket();
    socket.onopen = (data) => {
      socket.send(
        JSON.stringify({
          "action": "setlistener",
          "data": {
            'type': 'data',
            'dataId': user.user_id,
            'user-pool-id': environment.cognitoUserPoolId,
            'client-id': environment.cognitoClientId,
            'sub-domain': environment.domain
          }
        })
      );
    };

    return socket;

  }

  private resetSocket() {
    this.close(this.socketConnectionId);
    this.updateSocket = this.connectSocket();
    this.socketExpiration = moment().add(7, 'minutes');
    console.log("UPDATE SOCKET", this.updateSocket)
  }

  public refreshSocket(): Rx.Observable<any> {
    if (moment().isAfter(this.socketExpiration) ||
      !this.listener) {
      this.listener = new Rx.Subject
      this.userService.isLoggedIn().subscribe(
        (loggedIn) => {
          if (loggedIn) {
            this.resetSocket();
            this.setSocketListener();
          }
        })
    }
    return this.listener.asObservable();
  }

  private setSocketListener() {
    console.log("Subscribe to socket")

    this.updateSocket.onmessage = (event) => {
      const data = event.data.replace(/'/g, '"');
      const message = JSON.parse(data);
      this.listener.next(message);
    };

    this.updateSocket.onerror = (error) => {
      this.listener.error(error);
    };

  }

  /**
   * Get the socket url with appropriate protocol
   * */
  getSocketUrl() {
    let url = environment.socketUrl;
    if (!/^wss:\/\//gi.test(url)) {
      url = 'wss://' + url;
    }
    return url;
  }
}
